<template>
  <ed-input-item :label="label" :info="info" :name="name" :required="required">
    <el-select
      :value="value"
      :clearable="clearable"
      :loading="loading"
      :placeholder="placeholder"
      :disabled="disabled ? true : false"
      :multiple="multiple"
      :value-key="itemValue"
      :remote-method="remoteMethod"
      @change="$emit('input', $event)"
      @input="$emit('input', $event)"
      collapse-tags
      remote
      filterable
    >
      <el-option
        v-for="(item, index) in items"
        :key="index"
        :label="getLabel(item)"
        :value="getValue(item)"
      >
        <span v-html="getHtml(item)"></span>
      </el-option>
    </el-select>
  </ed-input-item>
</template>

<script>
import EdFormMixin from "./mixins/formControl";
import EdInputItem from "./EdInputItem";

export default {
  name: "EdInputAutoComplete",
  mixins: [EdFormMixin],
  components: { EdInputItem },
  props: {
    items: {
      type: [Array],
      required: false,
      default: function () {
        return [];
      },
    },
    itemValue: {
      type: [String, Function],
      required: false,
      default: "id",
    },
    itemText: {
      type: [String, Number, Function],
      required: false,
      default: "nome",
    },
    isObject: {
      type: [Boolean],
      required: false,
      default: false,
    },
  },
  data() {
    return {
      search: null,
      timerId: null,
    };
  },
  beforeDestroy() {},
  created() {},
  mounted() {
    this.remoteMethod = _.debounce(this.remoteMethod, 1000);
  },
  computed: {},
  methods: {
    remoteMethod(val) {
      this.$emit("search", val);
    },

    // remoteMethod: _.debounce(function (val) {

    //   if(val){
    //     this.$emit("search", val);
    //   }

    // }, 1000),

    getLabel(item) {
      let retorno = item[this.itemText];

      switch (this.itemText) {
        case "fdt":
          retorno = item.pcmso + " (" + item.descricao + ")";
          break;

        case "revisao":
          retorno = item.rev + " (" + item.descricao + ")";
          break;

        case "ghe":
          retorno = item.ghe + " (" + item.descricao + ")";
          break;

        case "funcionario":
          retorno = item.nome;
          break;

        case "esocial":
          retorno = item.codigo + " - " + item.nome;
          break;
      }

      return retorno;
    },

    getValue(item) {
      if (this.isObject) {
        return item;
      }

      return item[this.itemValue];
    },

    getHtml(item) {
      switch (this.itemText) {
        case "fdt":
          return item.pcmso + " (" + item.descricao + ")";
          break;

        case "revisao":
          return item.rev + " (" + item.descricao + ")";
          break;

        case "ghe":
          return item.ghe + " (" + item.descricao + ")";
          break;

        case "esocial":
          return item.codigo + " - " + item.nome;
          break;

        case "funcionario":
          return (
            item.nome +
            (item.funcao
              ? '<br><span style="font-size:8pt"><b>' +
                item.funcao.nome +
                "</b></span>"
              : "")
          );
          break;

        case "epi":
          return (
            (this.maxLenght
              ? '<span title="' +
                item.nome +
                '">' +
                this.$utilidade.textLimit(item.nome, this.maxLenght) +
                "</span>"
              : item.nome) +
            (item.ca ? " | <b>CA:</b> " + item.ca : "") +
            (item.categoria
              ? " | <b>Categoria:</b> " + item.categoria.nome
              : "")
          );
          break;

        default:
          return this.maxLenght ? '<span title="'+item[this.itemText]+'">'+this.$utilidade.textLimit(item[this.itemText],this.maxLenght)+'</span>' : item[this.itemText];
          break;
      }
    },
  },
  watch: {
    items() {},
  },
};
</script>



// WEBPACK FOOTER //
// EdInputAutoComplete.vue?7a2e3fc0